import React from "react";
import { Eye, EyeOff, Lock, Unlock, Trash2, Pin } from "lucide-react";
import { TOOL_LABELS } from "../../engine";

const fmtT = (epoch) => new Date(epoch * 1000).toLocaleTimeString([], { hour12: false });

// Object tree: every drawing on this symbol with visibility / lock / delete controls.
export default function ObjectsTree({ drawings, selectedId, onSelect, onUpdate, onRemove, onClear, tfId }) {
  return (
    <div data-testid="objects-tree">
      <div className="flex items-center justify-between px-3 py-2 border-b border-border">
        <div>
          <div className="text-sm font-semibold">Objects</div>
          <div className="text-[10px] text-muted-foreground">{drawings.length} on this symbol · click to select</div>
        </div>
        {drawings.length > 0 && <button data-testid="objects-clear" onClick={onClear} className="text-[11px] text-sell hover:underline">Remove all</button>}
      </div>
      <div className="max-h-72 overflow-y-auto scrollbar-thin p-1">
        {drawings.length === 0 && <div className="py-6 text-center text-xs text-muted-foreground" data-testid="objects-empty">No drawings yet — pick a tool on the rail.</div>}
        {drawings.map((d) => {
          const on = d.id === selectedId;
          const hiddenOnTf = d.timeframe && d.timeframe !== tfId;
          return (
            <div key={d.id} data-testid={`object-row-${d.id}`} onClick={() => onSelect(d.id)}
              className={`group flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer ${on ? "bg-primary/15" : "hover:bg-secondary"} ${!d.visible || hiddenOnTf ? "opacity-50" : ""}`}>
              <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ background: d.style.color }} />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium truncate">{d.text ? `${TOOL_LABELS[d.type]} · ${d.text}` : TOOL_LABELS[d.type]}</div>
                <div className="text-[10px] text-muted-foreground font-mono-nums flex items-center gap-1">
                  {d.points[0] && <>{d.points[0].price.toFixed(2)} · {fmtT(d.points[0].time)}</>}
                  {d.timeframe && <span className="inline-flex items-center gap-0.5 text-primary"><Pin className="h-2.5 w-2.5" />{d.timeframe}</span>}
                </div>
              </div>
              <button data-testid={`object-visible-${d.id}`} title={d.visible ? "Hide" : "Show"} onClick={(e) => { e.stopPropagation(); onUpdate(d.id, { visible: !d.visible }); }} className="h-6 w-6 rounded flex items-center justify-center text-muted-foreground hover:text-foreground">
                {d.visible ? <Eye className="h-3.5 w-3.5" /> : <EyeOff className="h-3.5 w-3.5" />}
              </button>
              <button data-testid={`object-lock-${d.id}`} title={d.locked ? "Unlock" : "Lock"} onClick={(e) => { e.stopPropagation(); onUpdate(d.id, { locked: !d.locked }); }} className={`h-6 w-6 rounded flex items-center justify-center ${d.locked ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}>
                {d.locked ? <Lock className="h-3.5 w-3.5" /> : <Unlock className="h-3.5 w-3.5" />}
              </button>
              <button data-testid={`object-delete-${d.id}`} title="Delete" onClick={(e) => { e.stopPropagation(); onRemove(d.id); }} className="h-6 w-6 rounded flex items-center justify-center text-muted-foreground hover:text-sell">
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
